module.exports = __webpack_public_path__ + "img/postback-step-8.en.b3eb22e3.jpg";